import React from 'react';
import { Avatar } from '@mui/material';
import {
    AccountTree,
    AdminPanelSettings,
    Diversity3,
    Groups,
    Handshake,
    HelpOutline,
    Insights
} from '@mui/icons-material';
import { ManagementFocus } from '@root/api';
import { HF_CTA_COLORS } from '@root/app/shared/theme/designTokens';

const FOCUS_ICONS: Record<ManagementFocus, React.ElementType> = {
    [ManagementFocus.TeamLead]: Groups,
    [ManagementFocus.ManagerOfManagers]: AccountTree,
    [ManagementFocus.Executive]: Insights,
    [ManagementFocus.PeopleAdvisor]: Handshake,
    [ManagementFocus.PeopleExecutive]: Diversity3,
    [ManagementFocus.AccountAdmin]: AdminPanelSettings,
    [ManagementFocus.Generic]: HelpOutline
};

interface HfFocusIconProps {
    focus: ManagementFocus;
    /* Diameter of the circle, in px. */
    size?: number;
}

/* A focus's icon in a light-blue circle, the same wherever foci are listed. */
const HfFocusIcon: React.FC<HfFocusIconProps> = ({ focus, size = 36 }) => {
    const Icon = FOCUS_ICONS[focus];
    return (
        <Avatar sx={{ width: size, height: size, bgcolor: HF_CTA_COLORS[100], color: HF_CTA_COLORS[600] }}>
            {Icon && <Icon sx={{ fontSize: Math.round(size * 0.55) }} />}
        </Avatar>
    );
};

export default HfFocusIcon;
